export default "__VITE_ASSET__8DP_nLqX__"